'use client'

import {
  Box,
  Flex,
  Text,
  IconButton,
  Button,
  Stack,
  Collapse,
  Icon,
  Popover,
  PopoverTrigger,
  PopoverContent,
  useColorModeValue,
  useBreakpointValue,
  useDisclosure,
  useColorMode,
  Image,
} from '@chakra-ui/react'
import {
  HamburgerIcon,
  CloseIcon,
  ChevronDownIcon,
  ChevronRightIcon,
} from '@chakra-ui/icons'

import { MoonIcon, SunIcon } from '@chakra-ui/icons'
import { useNavigate } from "react-router-dom";
import { useAuth } from '../../contexts/AuthContext';

const Logo = (props) => {
  return (
    <svg {...props} width="101.40000000000003" height="34.3960851470911" viewBox="0 0 370 155.55037422150684" className="looka-1j8o68f"><defs id="SvgjsDefs1841"></defs><g id="SvgjsG1842" featurekey="odWo6G-0" transform="matrix(1.807793655095557,0,0,1.807793655095557,0.002308929112040257,-0.0003937560298522078)" fill="#f73859"><switch xmlns="http://www.w3.org/2000/svg"><foreignObject requiredExtensions="http://ns.adobe.com/AdobeIllustrator/10.0/" x="0" y="0" width="1" height="1"></foreignObject><g xmlns="http://ns.adobe.com/AdobeIllustrator/10.0/" extraneous="self"><g><g><path fillRule="evenodd" clipRule="evenodd" d="M32.583,0.001c0.471,0.595,0.454,1.518,0.532,2.499      c0.192,2.422,0.192,5.256,0.865,7.434c0.063,0.203,0.074,0.479,0.133,0.563c0.128,0.185,0.37,0.235,0.599,0.375      c0.13,0.079,0.388,0.199,0.599,0.313c0.137,0.074,0.227,0.192,0.333,0.25c0.149,0.081,0.327,0.112,0.466,0.188      c0.119,0.064,0.215,0.183,0.333,0.25c0.273,0.156,0.581,0.247,0.798,0.375c0.026,0.015,0.044,0.116,0.066,0.125      c0.034,0.014,0.103-0.019,0.134,0c0.024,0.016,0.045,0.116,0.066,0.125c0.263,0.111,0.576,0.323,0.864,0.5      c0.13,0.08,0.272,0.107,0.399,0.188c0.024,0.016,0.045,0.116,0.066,0.125c0.034,0.015,0.103-0.019,0.134,0      c0.024,0.016,0.045,0.116,0.066,0.125c0.125,0.053,0.311,0.147,0.466,0.25c0.286,0.189,0.558,0.346,0.798,0.562      c0.029,0.026,0.173,0.122,0.267,0.188c0.65,0.456,1.396,1.021,2.063,1.562c0.406,0.329,0.799,0.743,1.198,1.187      c0.044,0.05,0.16,0.073,0.199,0.125c0.045,0.06,0.021,0.134,0.066,0.187c0.11,0.128,0.236,0.188,0.333,0.313      c0.084,0.109,0.114,0.247,0.199,0.375c0.34,0.513,0.66,0.985,0.799,1.812c0.069,0.416,0.121,0.939,0.066,1.375      c-0.063,0.502-0.28,0.966-0.532,1.375c-0.12,0.195-0.347,0.567-0.532,0.812c-0.148,0.195-0.367,0.36-0.532,0.563      c-0.044,0.053-0.022,0.081-0.066,0.125c-0.102,0.1-0.261,0.343-0.399,0.5c-1.121,1.262-2.523,2.601-3.261,4.248      c-1.262,2.822-1.277,7.543-0.932,11.37c0.359,3.976,1.176,7.287,2.329,10.434c0.764,2.083,1.647,3.979,2.928,5.622      c0.473,0.606,0.976,1.162,1.53,1.749c0.084,0.089,0.187,0.164,0.267,0.25c0.095,0.103,0.11,0.218,0.199,0.313      c0.092,0.098,0.23,0.137,0.333,0.25c0.09,0.1,0.108,0.22,0.199,0.313c0.129,0.133,0.334,0.213,0.466,0.375      c0.033,0.04,0.026,0.146,0.066,0.188c0.183,0.188,0.41,0.305,0.599,0.499c0.087,0.09,0.12,0.228,0.2,0.313      c0.094,0.102,0.18,0.16,0.266,0.25c0.883,0.92,1.792,1.789,2.662,2.749c0.093,0.103,0.174,0.215,0.266,0.313      c0.135,0.143,0.233,0.271,0.399,0.438c0.244,0.245,0.532,0.672,0.799,0.999c0.315,0.389,0.687,0.771,0.998,1.188      c0.079,0.106,0.117,0.26,0.199,0.374c0.072,0.102,0.191,0.143,0.267,0.25c0.043,0.063,0.028,0.13,0.066,0.188      c0.064,0.098,0.252,0.279,0.332,0.438c0.061,0.119,0.078,0.301,0.134,0.438c0.62,1.54,0.714,4.08,0.399,6.122      c-0.139,0.899-0.345,1.824-0.6,2.624c-0.049,0.154-0.076,0.282-0.133,0.438c-0.106,0.294-0.369,0.72-0.532,1.062      c-0.069,0.146-0.066,0.308-0.133,0.438c-0.055,0.106-0.145,0.216-0.2,0.313c-0.102,0.177-0.218,0.327-0.332,0.5      c-0.207,0.312-0.529,0.735-0.799,1.062c-0.086,0.104-0.126,0.234-0.199,0.313c-0.232,0.248-0.572,0.565-0.865,0.813      c-0.182,0.153-0.375,0.321-0.599,0.5c-0.134,0.105-0.258,0.184-0.399,0.312c-0.06,0.054-0.146,0.046-0.267,0.125      c-0.099,0.066-0.163,0.187-0.266,0.25c-0.107,0.066-0.273,0.116-0.399,0.188c-2.577,1.462-6.224,2.235-10.114,2.562      c-2.836,0.237-5.641,0.134-8.317-0.25c-1.293-0.185-2.512-0.448-3.726-0.75c-0.603-0.149-1.228-0.256-1.797-0.437      c-0.122-0.039-0.276-0.146-0.399-0.188c-0.273-0.092-0.492-0.137-0.798-0.25c-1.097-0.404-2.365-0.988-3.327-1.624      c-0.216-0.144-0.389-0.339-0.599-0.5c-0.06-0.046-0.144-0.082-0.2-0.125c-0.083-0.063-0.154-0.17-0.266-0.25      c-0.044-0.032-0.154-0.024-0.2-0.063c-0.392-0.327-0.725-0.709-1.064-1.063c-1.438-1.494-2.631-3.181-3.66-4.997      c-0.027-0.048-0.043-0.069-0.066-0.125c-0.376-0.904-0.544-1.936-0.732-2.999c-0.527-2.98-0.838-6.598-0.732-10.183      c0.117-3.946,1.339-7.23,2.462-10.371c0.466-1.305,0.963-2.633,1.464-4.123c0.305-0.908,0.642-1.835,0.865-2.812      c0.57-2.496,0.613-5.693,0.066-8.246c-0.086-0.402-0.144-0.675-0.266-1.125c-0.127-0.468-0.389-1.198-0.599-1.687      c-0.288-0.669-0.601-1.232-0.998-1.812c-0.228-0.332-0.502-0.721-0.799-1.062c-0.649-0.747-1.619-1.552-2.661-2      c-1.085-0.465-2.53-0.646-3.793-0.063c-0.251,0.116-0.517,0.273-0.732,0.438c-0.599,0.458-1.317,1.403-1.131,2.374      c0.096,0.505,0.304,0.882,0.732,1.25c0.384,0.33,0.869,0.598,1.397,0.625c0.965,0.05,1.758-0.478,2.329-1.187      c0.059-0.125,0.291,0.028,0.133,0.063c-0.033,1.846-0.446,3.259-1.198,4.498c-0.052,0.086-0.09,0.189-0.133,0.25      c-0.073,0.105-0.239,0.203-0.333,0.313c-0.049,0.057-0.087,0.134-0.133,0.188c-0.372,0.428-0.901,0.844-1.53,1.125      c-1.368,0.609-3.57,0.5-5.057-0.125c-1.124-0.472-2.029-1.259-2.595-2.187c-1.405-2.301-0.987-5.276-0.067-7.497      c0.934-2.252,2.459-3.957,4.325-5.06c0.522-0.309,1.034-0.605,1.597-0.812c1.759-0.646,4.108-0.767,6.254-0.188      c1.024,0.276,2.079,0.708,2.994,1.187c0.142,0.074,0.276,0.119,0.399,0.187c0.027,0.015,0.043,0.115,0.066,0.125      c0.28,0.119,0.58,0.282,0.865,0.5c0.104,0.08,0.202,0.135,0.333,0.25c0.08,0.07,0.21,0.143,0.333,0.25      c0.303,0.267,0.742,0.59,1.065,0.938c1.537,1.654,2.493,3.727,3.327,6.06c0.432,1.208,0.792,2.375,0.932,3.686      c0.077,0.722,0.133,1.445,0.133,2.187c0,2.068-0.312,4.302-0.665,6.185c-0.245,1.306-0.519,2.562-0.865,3.749      c-0.063,0.218-0.217,0.482-0.266,0.687c-0.019,0.079,0.023,0.173,0,0.25c-0.109,0.357-0.277,0.675-0.399,1.063      c-0.18,0.57-0.426,1.326-0.665,1.937c-0.279,0.711-0.732,1.613-1.065,2.374c-0.169,0.387-0.404,1.037-0.532,1.562      c-0.266,1.093-0.474,2.639-0.532,3.998c-0.08,1.873,0.056,3.78,0.666,5.311c0.556-1.105,0.966-2.186,1.464-3.186      c0.391-0.788,0.755-1.532,1.198-2.312c0.141-0.25,0.262-0.51,0.399-0.75c0.016-0.027,0.123-0.04,0.133-0.063      c0.446-0.93,1.111-1.877,1.73-2.749c0.944-1.329,2.059-2.596,3.26-3.748c0.397-0.382,0.741-0.82,1.132-1.188      c0.983-0.924,1.938-1.729,2.728-2.873c0.298-0.432,0.601-1.092,0.798-1.75c0.428-1.419,0.5-3.301,0.267-5.123      c-0.334-2.608-1.171-5.003-2.13-7.122c-0.416-0.92-0.865-1.785-1.396-2.686c-0.07-0.118-0.133-0.269-0.199-0.375      c-0.017-0.025-0.123-0.041-0.134-0.063c-0.04-0.083-0.067-0.152-0.133-0.25c-0.218-0.325-0.462-0.677-0.731-1      c-0.357-0.425-0.738-0.788-1.132-1.187c-0.758-0.769-1.494-1.613-2.196-2.499c-1.376-1.736-2.513-3.597-3.327-5.935      c-0.401-1.151-0.754-2.476-0.798-3.749c-0.054-1.53,0.313-3.028,0.665-4.436c0.343-1.37,0.675-2.704,1.131-3.998      c0.407-1.154,0.984-2.452,1.53-3.624c0.25-0.536,0.493-1.09,0.865-1.75c0.27-0.478,0.802-1.406,1.131-1.437      c0.312-0.029,0.597,0.3,0.798,0.625c0.505,0.814,0.503,2.376,0.466,3.624c-0.027,0.899-0.105,1.578-0.133,2.562      c-0.021,0.746,0.009,2.432,0.798,2.062c0.132-0.062,0.063-0.009,0.134-0.125c0.07-0.119-0.01-0.208,0.066-0.438      c0.162-0.495,0.516-1.748,0.665-2.187c0.356-1.052,0.731-2.011,1.064-2.749c0.335-0.744,0.841-1.843,1.265-2.562      c0.133-0.227,0.295-0.473,0.465-0.75c0.035-0.056,0.105-0.082,0.134-0.125c0.053-0.082,0.072-0.229,0.133-0.313      c0.116-0.161,0.326-0.339,0.466-0.5c0.161-0.186,0.213-0.363,0.466-0.5C32.235,0.098,32.385-0.01,32.583,0.001z"></path><path fillRule="evenodd" clipRule="evenodd" d="M54.074,25.615c-1.179-0.554-2.381-1.119-3.659-1.624      c-0.132-0.052-0.248-0.067-0.399-0.125c-0.432-0.165-0.942-0.348-1.597-0.5c-0.141-0.033-0.272-0.111-0.399-0.125      c-0.374-0.041-0.746,0.081-1.131-0.063c0.077-0.718,0.688-0.936,0.798-1.624c0.045,0,0.089,0,0.134,0      c0.577-0.036,1.056,0.291,1.464,0.5c0.151,0.078,0.337,0.113,0.466,0.188c0.025,0.015,0.044,0.116,0.066,0.125      c0.033,0.015,0.103-0.019,0.133,0c0.024,0.016,0.045,0.116,0.066,0.125c0.034,0.014,0.103-0.019,0.133,0      c0.025,0.016,0.045,0.116,0.067,0.125c0.033,0.014,0.102-0.019,0.133,0c0.024,0.016,0.045,0.116,0.066,0.125      c0.263,0.111,0.589,0.368,0.865,0.562c1.001,0.706,1.977,1.432,2.86,2.249"></path><line fillRule="evenodd" clipRule="evenodd" x1="54.14" y1="25.552" x2="54.074" y2="25.552"></line><path fillRule="evenodd" clipRule="evenodd" d="M54.074,25.552c0.075,0.11,0.241,0.115,0.3,0.219"></path><line fillRule="evenodd" clipRule="evenodd" x1="54.074" y1="25.552" x2="54.074" y2="25.615"></line><path fillRule="evenodd" clipRule="evenodd" d="M48.884,29.801c-0.204-0.195-0.43-0.432-0.599-0.688      c-0.032-0.048-0.027-0.132-0.067-0.188c-0.075-0.105-0.192-0.153-0.266-0.25c-0.38-0.501-0.733-0.955-1.131-1.437      c-0.151-0.184-0.294-0.354-0.466-0.563c-0.075-0.091-0.116-0.216-0.2-0.312c-0.146-0.168-0.366-0.32-0.532-0.5      c-0.133-0.144-0.271-0.412-0.466-0.562c-0.188-0.147-0.492-0.202-0.665-0.375c0.185-0.5,0.602-0.944,1.331-0.875      c0.919,0.087,1.706,1.581,2.063,2.374c0.514,1.144,0.884,2.274,1.064,3.249"></path><line fillRule="evenodd" clipRule="evenodd" x1="48.951" y1="29.676" x2="48.895" y2="29.728"></line><path fillRule="evenodd" clipRule="evenodd" d="M48.984,29.957c-0.039-0.073,0-0.184-0.089-0.229"></path><line fillRule="evenodd" clipRule="evenodd" x1="48.895" y1="29.728" x2="48.884" y2="29.801"></line></g></g></g></switch></g><g id="SvgjsG1843" featurekey="VGK2BT-0" transform="matrix(6.057097310610346,0,0,6.057097310610346,115.37898345000936,-17.606594598151673)" fill="#f73859"><path d="M8.2371 19.62712 c-0.22034 -1.661 -0.2368 -3.2032 -0.16916 -4.8302 c0.084746 -2 -1.0169 -3.2881 -3.0847 -3.2881 c-1.3559 0 -2.7627 0.40678 -3.5932 0.86441 c-0.15254 0.084746 -0.25424 0.23712 -0.18644 0.38966 l0.42373 0.98305 c0.067797 0.16949 0.18644 0.22034 0.40678 0.11864 c1.0847 -0.49153 1.9661 -0.72881 2.8305 -0.72881 c0.91525 0 1.4576 0.35593 1.4237 1.322 c-3.1356 0.5422 -5.5254 1.1015 -5.5254 3.3049 c0 1.4746 1.0678 2.3219 2.7966 2.3219 c1.4408 0 2.1864 -0.44051 2.8983 -0.98288 c0.08458 0.50847 0.23712 0.89831 0.5761 0.89831 l1.0169 0 c0.15238 0 0.20322 -0.18644 0.18627 -0.37288 z M3.8815 18.627299999999998 c-0.69492 0 -1.2373 -0.23729 -1.2373 -0.88136 c0 -1.0339 1.8981 -1.3729 3.6102 -1.7288 c-0.016949 0.55932 -0.016949 1.3051 0 1.7966 c-0.55932 0.42373 -1.5085 0.81356 -2.3729 0.81356 z M16.118491525423728 12.034099999999999 c0.18644 0.11864 0.23729 0.22017 0.11848 0.40661 l-0.69475 1.0169 c-0.084746 0.11864 -0.20339 0.15254 -0.35593 0.11864 c-0.35593 -0.16949 -0.66102 -0.32203 -1.2203 -0.32203 s-1.4407 0.23729 -1.9153 1.2881 l0 5.1866 c0 0.15238 -0.10169 0.27102 -0.25424 0.27102 l-1.339 0 c-0.15254 0 -0.25424 -0.11864 -0.25424 -0.27102 l0 -7.8476 c0 -0.15238 0.11864 -0.27119 0.25424 -0.27119 l0.9322 0 c0.40678 0 0.66102 0.42373 0.66102 0.72881 l0 0.11881 c0.59322 -0.54237 1.3051 -0.91525 2.2373 -0.91525 c0.86441 0 1.5085 0.27119 1.8305 0.49153 z M21.50832542372881 20.11864 c2.3729 0 4.339 -1.8812 4.339 -4.3049 c0 -2.4746 -1.9661 -4.322 -4.339 -4.322 s-4.339 1.8475 -4.339 4.322 c0 2.4237 1.9661 4.3049 4.339 4.3049 z M21.50832542372881 18.39 c-1.4576 0 -2.5424 -1.2034 -2.5424 -2.5593 c0 -1.4068 1.0847 -2.6102 2.5424 -2.6102 s2.5424 1.2034 2.5424 2.6102 c0 1.3559 -1.0847 2.5593 -2.5424 2.5593 z M33.37272881355932 12.034099999999999 c0.18644 0.11864 0.23729 0.22017 0.11848 0.40661 l-0.69475 1.0169 c-0.084746 0.11864 -0.20339 0.15254 -0.35593 0.11864 c-0.35593 -0.16949 -0.66102 -0.32203 -1.2203 -0.32203 s-1.4407 0.23729 -1.9153 1.2881 l0 5.1866 c0 0.15238 -0.10169 0.27102 -0.25424 0.27102 l-1.339 0 c-0.15254 0 -0.25424 -0.11864 -0.25424 -0.27102 l0 -7.8476 c0 -0.15238 0.11864 -0.27119 0.25424 -0.27119 l0.9322 0 c0.40678 0 0.66102 0.42373 0.66102 0.72881 l0 0.11881 c0.59322 -0.54237 1.3051 -0.91525 2.2373 -0.91525 c0.86441 0 1.5085 0.27119 1.8305 0.49153 z M42.03371016949152 19.62712 c-0.22034 -1.661 -0.2368 -3.2032 -0.16916 -4.8302 c0.084746 -2 -1.0169 -3.2881 -3.0847 -3.2881 c-1.3559 0 -2.7627 0.40678 -3.5932 0.86441 c-0.15254 0.084746 -0.25424 0.23712 -0.18644 0.38966 l0.42373 0.98305 c0.067797 0.16949 0.18644 0.22034 0.40678 0.11864 c1.0847 -0.49153 1.9661 -0.72881 2.8305 -0.72881 c0.91525 0 1.4576 0.35593 1.4237 1.322 c-3.1356 0.5422 -5.5254 1.1015 -5.5254 3.3049 c0 1.4746 1.0678 2.3219 2.7966 2.3219 c1.4408 0 2.1864 -0.44051 2.8983 -0.98288 c0.08458 0.50847 0.23712 0.89831 0.5761 0.89831 l1.0169 0 c0.15238 0 0.20322 -0.18644 0.18627 -0.37288 z M37.678110169491525 18.627299999999998 c-0.69492 0 -1.2373 -0.23729 -1.2373 -0.88136 c0 -1.0339 1.8981 -1.3729 3.6102 -1.7288 c-0.016949 0.55932 -0.016949 1.3051 0 1.7966 c-0.55932 0.42373 -1.5085 0.81356 -2.3729 0.81356 z"></path></g></svg>
  )
}


export default function WithSubnavigation() {
  const { isOpen, onToggle } = useDisclosure()
  const { colorMode, toggleColorMode } = useColorMode()

  return (
    <Box>
      <Flex
        bg={useColorModeValue('white', 'gray.800')}
        color={useColorModeValue('gray.600', 'white')}
        minH={'60px'}
        py={{ base: 2 }}
        px={{ base: 4 }}
        borderBottom={1}
        borderStyle={'solid'}
        borderColor={useColorModeValue('gray.200', 'gray.900')}
        align={'center'}>
        <Flex
          flex={{ base: 1, md: 'auto' }}
          ml={{ base: -2 }}
          display={{ base: 'flex', md: 'none' }}>
          <IconButton
            onClick={onToggle}
            icon={isOpen ? <CloseIcon w={3} h={3} /> : <HamburgerIcon w={5} h={5} />}
            variant={'ghost'}
            aria-label={'Toggle Navigation'}
          />
        </Flex>
        <Flex flex={{ base: 1 }} justify={{ base: 'center', md: 'space-between' }} paddingRight={'20px'}>
          <Logo />
          <Button onClick={toggleColorMode} alignSelf={'center'}>
            {colorMode === 'light' ? <MoonIcon /> : <SunIcon />}
          </Button>
        </Flex>

        <Stack
          flex={{ base: 1, md: 0 }}
          justify={'flex-end'}
          direction={'row'}
          spacing={6}>
          <Button as={'a'} fontSize={'sm'} fontWeight={400} variant={'link'} href={'#'}>
            Sign Out
          </Button>
          <Flex display={{ base: 'none', md: 'flex' }} ml={10}>
            <DesktopNav />
          </Flex>
        </Stack>
      </Flex>

      <Collapse in={isOpen} animateOpacity>
        <MobileNav />
      </Collapse>
    </Box>
  )
}

const DesktopNav = () => {
  const linkColor = useColorModeValue('gray.600', 'gray.200')
  const linkHoverColor = useColorModeValue('gray.800', 'white')
  const popoverContentBgColor = useColorModeValue('white', 'gray.800')

  return (
    <Stack direction={'row'} alignItems={'flex-end'} spacing={4}>
      {NAV_ITEMS.map((navItem) => (
        <Box key={navItem.label}>
          <Popover trigger={'hover'} placement={'bottom-start'}>
            <PopoverTrigger>
              <Box
                as="a"
                p={2}
                href={navItem.href ?? '#'}
                fontSize={'sm'}
                fontWeight={500}
                color={linkColor}
                _hover={{
                  textDecoration: 'none',
                  color: linkHoverColor,
                }}>
                {navItem.label}
              </Box>
            </PopoverTrigger>

            {navItem.children && (
              <PopoverContent
                border={0}
                boxShadow={'xl'}
                bg={popoverContentBgColor}
                p={4}
                rounded={'xl'}
                minW={'sm'}>
                <Stack>
                  {navItem.children.map((child) => (
                    <DesktopSubNav key={child.label} {...child} />
                  ))}
                </Stack>
              </PopoverContent>
            )}
          </Popover>
        </Box>
      ))}
    </Stack>
  )
}

const DesktopSubNav = ({ label, href, subLabel }) => {
  return (
    <Box
      as="a"
      href={href}
      role={'group'}
      display={'block'}
      p={2}
      rounded={'md'}
      _hover={{ bg: useColorModeValue('pink.50', 'gray.900') }}>
      <Stack direction={'row'} align={'center'}>
        <Box>
          <Text
            transition={'all .3s ease'}
            _groupHover={{ color: 'pink.400' }}
            fontWeight={500}>
            {label}
          </Text>
          <Text fontSize={'sm'}>{subLabel}</Text>
        </Box>
        <Flex
          transition={'all .3s ease'}
          transform={'translateX(-10px)'}
          opacity={0}
          _groupHover={{ opacity: '100%', transform: 'translateX(0)' }}
          justify={'flex-end'}
          align={'center'}
          flex={1}>
          <Icon color={'pink.400'} w={5} h={5} as={ChevronRightIcon} />
        </Flex>
      </Stack>
    </Box>
  )
}

const MobileNav = () => {
  return (
    <Stack bg={useColorModeValue('white', 'gray.800')} p={4} display={{ md: 'none' }}>
      {NAV_ITEMS.map((navItem) => (
        <MobileNavItem key={navItem.label} {...navItem} />
      ))}
    </Stack>
  )
}

const MobileNavItem = ({ label, children, href }) => {
  const { isOpen, onToggle } = useDisclosure()

  return (
    <Stack spacing={4} onClick={children && onToggle}>
      <Box
        py={2}
        as="a"
        href={href ?? '#'}
        justifyContent="space-between"
        alignItems="center"
        _hover={{
          textDecoration: 'none',
        }}>
        <Text fontWeight={600} color={useColorModeValue('gray.600', 'gray.200')}>
          {label}
        </Text>
        {children && (
          <Icon
            as={ChevronDownIcon}
            transition={'all .25s ease-in-out'}
            transform={isOpen ? 'rotate(180deg)' : ''}
            w={6}
            h={6}
          />
        )}
      </Box>

      <Collapse in={isOpen} animateOpacity style={{ marginTop: '0!important' }}>
        <Stack
          mt={2}
          pl={4}
          borderLeft={1}
          borderStyle={'solid'}
          borderColor={useColorModeValue('gray.200', 'gray.700')}
          align={'start'}>
          {children &&
            children.map((child) => (
              <Box as="a" key={child.label} py={2} href={child.href}>
                {child.label}
              </Box>
            ))}
        </Stack>
      </Collapse>
    </Stack>
  )
}


const NAV_ITEMS = [
  {
    label: 'Contact',
    href: 'http://localhost:3000/contact',
  },
]